import React from 'react';

import { createIcon } from '../createIcon';

function SvgTimeCircle(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M8 2a5.99 5.99 0 00-6 6c0 3.321 2.679 6 6 6s6-2.679 6-6-2.679-6-6-6zm0 1.286A4.68 4.68 0 0112.714 8 4.68 4.68 0 018 12.714 4.68 4.68 0 013.286 8 4.68 4.68 0 018 3.286zm-.857 1.83V7.76l.153.185L8.54 9.29c.2.217.537.23.754.03l.03-.03a.625.625 0 000-.848l-1.09-1.18V5.117a.545.545 0 10-1.09 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const TimeCircleOutlinedIcon = createIcon(SvgTimeCircle, 'TimeCircleOutlinedIcon');
